import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../_services/translate.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(key: any, page: any, params?: any): any {
    const pageData = this.translate.data && this.translate.data[page];
    let value = (pageData && pageData[key]) || key;

    if (params && typeof value === 'string') {
      for (const k of Object.keys(params)) {
        const token = `{${k}}`;
        value = value.split(token).join(String(params[k]));
      }
    }

    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/translate/translate.pipe.ts